module.exports = __webpack_public_path__ + "static/media/19ESCAP21.ea64c330.jpg";